import { Network } from '@kattana-io/common';
import WalletField from '../../../../molecules/WalletField';
import { WatchlistWallet } from '../../../../reducers/wallet_watchlist';
import Text from '../../../../atoms/Text';

interface IWalletAddressChainMobile {
  wallet: WatchlistWallet;
}

const WalletAddressChainMobile = ({ wallet }: IWalletAddressChainMobile) => {
  return (
    <div className='price__change_cell'>
      <WalletField
        wallet={wallet.address}
        network={wallet.chain}
        textProps={{
          size: 14,
          className: 'text--grey-200',
        }}
        showTag={false}
      />
      <Text size={14} className='text--grey-400'>
        {Network.isValidChain(wallet.chain)
          ? Network.fromChain(wallet.chain).getTitle()
          : wallet.chain}
      </Text>
    </div>
  );
};

export default WalletAddressChainMobile;
